// Maps language Uids from TYPO3 onto locale codes used for translation files
const getLocale = (languageUid) => {
    switch (languageUid) {
        case '0':
            return 'de_de';
        case '1':
            return 'en_gb';
        case '3':
            return 'fr_fr';
        case '5':
            return 'nl_nl';
        case '6':
            return 'de_ch';
        case '7':
            return 'de_at';
        case '8':
            return 'fr_be';
        case '9':
            return 'nl_be';
        case '10':
            return 'no_no';
        case '11':
            return 'sv_se';
        default:
            return '';
    }
};

export default getLocale;
